import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-2 overflow-hidden" }

import ShortMessageIcons from './ShortMessageIcons.vue';
import SMSShortMessage from './SMSShortMessage.vue';
import FaxShortMessage from './FaxShortMessage.vue';
import PhysicalMailShortMessage from './PhysicalMailShortMessage.vue';
import CallShortMessage from './CallShortMessage.vue';
import EmailShortMessage from './EmailShortMessage.vue';
import { computed } from 'vue';
import { ShortMessage } from '../../composition';


export default /*#__PURE__*/_defineComponent({
  __name: 'ShortMessage',
  props: {
    message: null,
    isUnread: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	message: ShortMessage;
	isUnread: boolean;
};



const ShortMessageComponent = computed(() => {
	switch (props.message.type) {
		case 'call':
			return CallShortMessage;
		case 'email':
			return EmailShortMessage;
		case 'text-message':
			return SMSShortMessage;
		case 'fax':
			return FaxShortMessage;
		case 'physical-mail':
			return PhysicalMailShortMessage;
		default:
			return null;
	}
});

function getMessageRecord(message: any) {
	if (!message || !message?.content?.records?.[0]) {
		return;
	}

	return {
		type: message.content.records[0].type,
		transcriptionText:
			message.content.records[0].transcriptionText,
		recordingUrl:
			message.content.records[0].recordingUrl
	};
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ShortMessageIcons, { message: __props.message }, null, 8, ["message"]),
    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(ShortMessageComponent)), {
      isUnread: __props.isUnread,
      message: __props.message
    }, null, 8, ["isUnread", "message"]))
  ]))
}
}

})